export default __webpack_public_path__ + "static/media/parlament_tansparent_logo.da52d8b0.png";